export const OUTPUT_TYPES = ['image', 'video', 'audio'] as const
export const INPUT_TYPES = ['upload', ...OUTPUT_TYPES] as const

const ID = '[1-9]\\d*'
const alt = (types: readonly string[]) => types.join('|')

/** Finds `{{type_n}}` tokens embedded in text. */
export const TOKEN = new RegExp(`\\{\\{(${alt(INPUT_TYPES)})_${ID}\\}\\}`, 'g')

/** Validates a single output ref (`image_1`, `@image_1`, `{{image_1}}`) and captures the bare id. */
export const OUTPUT_TOKEN = new RegExp(`^(?:\\{\\{)?@?((?:${alt(OUTPUT_TYPES)})_${ID})(?:\\}\\})?$`)

export function tokenLabel(token: string) {
  const body = token.replace(/\{\{|\}\}/g, '')
  const [kind, number] = body.split('_')
  const name = kind ? kind.charAt(0).toUpperCase() + kind.slice(1) : 'Asset'
  return `${name} ${number ?? ''}`.trim()
}
